@if (chartData) {
  <app-pchart type="bar" [data]="chartData" />
}

<div class="table-responsive">
  @if (chartData) {
    <table class="table table-sm">
      <thead class="thead-inverse inverse-grey">
        <tr>
          <th></th>
          <th>Mon</th>
          <th>Tue</th>
          <th>Wed</th>
          <th>Thu</th>
          <th>Fri</th>
          <th>Sat</th>
          <th>Sun</th>
          <th>Week Total</th>
        </tr>
      </thead>
      @if (data) {
        <tbody>
          @for (week of chartData.datasets; track week; let i = $index) {
            <tr>
              <td>
                @if (i) {
                  <span>Previous</span>
                }
                @if (!i) {
                  <span>This</span>
                }
                Week
              </td>
              @for (item of week.data; track item; let i = $index) {
                <td>
                  {{ item }}
                </td>
              }
              <td>{{ week.total }}</td>
            </tr>
          }
          <tr>
            <td>% change</td>
            @for (item of chartData.datasets[1].perc; track item; let i = $index) {
              <td [class.positive]="item >= 0" [class.negative]="item < 0">
                <span>
                  <app-perc-change [value]="item"></app-perc-change>
                </span>
              </td>
            }
            <td [class.positive]="chartData.percTotalChange >= 0" [class.negative]="chartData.percTotalChange < 0">
              <app-perc-change [value]="chartData.percTotalChange"></app-perc-change>
            </td>
          </tr>
        </tbody>
      }
    </table>
  }
</div>
